var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"20px"},attrs:{"id":"app1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }